/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface AppendToRegistries200Response
 */
export interface AppendToRegistries200Response {
  /**
   *
   * @type {boolean}
   * @memberof AppendToRegistries200Response
   */
  status: boolean
  /**
   *
   * @type {Array<string>}
   * @memberof AppendToRegistries200Response
   */
  data: Array<string>
}

/**
 * Check if a given object implements the AppendToRegistries200Response interface.
 */
export function instanceOfAppendToRegistries200Response(
  value: object
): value is AppendToRegistries200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function AppendToRegistries200ResponseFromJSON(
  json: any
): AppendToRegistries200Response {
  return AppendToRegistries200ResponseFromJSONTyped(json, false)
}

export function AppendToRegistries200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AppendToRegistries200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: json['data'],
  }
}

export function AppendToRegistries200ResponseToJSON(
  value?: AppendToRegistries200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: value['data'],
  }
}
